export default __webpack_public_path__ + "static/events-ideas-golf-3751af45d8ffdae845ff4865c541252b.jpg";